module.exports = __webpack_public_path__ + "img/50_6.aeac8fd8.png";